import WMSCM from './libs/wmscm';

document.addEventListener('DOMContentLoaded', () => {
	const wmscm = new WMSCM();
	console.log('starting wmscm');
});
